import Bugsnag from '@bugsnag/js'
import { addHours } from 'date-fns'
import jwt_decode from 'jwt-decode'
import { LoaderFunctionArgs } from 'react-router'
import Cookies from 'universal-cookie'

import { DecodedJwt } from '@shared/contexts/authenticationContext'

type CookieData = {
  status: 'success' | 'expired' | 'not-found'
  value?: any
  expiresAt?: number
}

const DEFAULT_COOKIE_EXPIRATION_HOURS = 24
export const AUTH_COOKIE_NAME = 'agile'

export class CookieManager {
  private readonly cookieName: string
  private readonly args?: LoaderFunctionArgs
  private readonly cookie: Cookies
  private expires: Date

  constructor(cookieName: string, args?: LoaderFunctionArgs, expire?: Date) {
    this.args = args
    this.cookieName = cookieName
    this.expires = expire ?? addHours(new Date(), DEFAULT_COOKIE_EXPIRATION_HOURS)
    if (this.args) {
      this.cookie = new Cookies(this.args.request.headers.get('cookie'))
    } else {
      this.cookie = new Cookies()
    }
  }

  getCookie(): CookieData {
    const cookieString = this.cookie.get(this.cookieName, { doNotParse: true })
    if (!cookieString) return { status: 'not-found' }

    try {
      const cookieData = JSON.parse(cookieString)

      // Check if expired
      if (Date.now() > cookieData.expiresAt) {
        return { status: 'expired', ...cookieData }
      }

      return { status: 'success', ...cookieData }
    } catch (e: any) {
      Bugsnag.notify(e)

      return {
        status: 'not-found',
      }
    }
  }

  setCookie(value: string) {
    const decoded = jwt_decode(value) as DecodedJwt
    const cookieData = {
      value: value,
      expiresAt: decoded.exp * 1000,
    }
    this.expires = new Date(cookieData.expiresAt)
    this.cookie.set(this.cookieName, JSON.stringify(cookieData), {
      expires: this.expires,
      path: '/',
    })
  }

  deleteCookie() {
    this.cookie.remove(this.cookieName, { path: '/' })
  }
}
